import React from 'react';
import type { PrimaryNavId } from './FmRouteCatalog';

export interface FmNavActiveState {
  /** Current route's primary navigation owner */
  activePrimaryNavId?: PrimaryNavId;
  /** Route id matching the current path */
  activeRouteId?: string;
}

export interface FmNavActiveContextValue {
  state: FmNavActiveState;
  [key: string]: unknown; // Allow additional catalog/navigation properties
}

export const NavActiveContext = React.createContext<FmNavActiveContextValue | undefined>(
  undefined,
);

export { useFmNavActive } from './useFmNavActive';
